export default class QueryFiltersModalController {
	/* @ngInject */
	constructor(
		query,
		$uibModalInstance,
	) {
		this.query = query;
		this.$uibModalInstance = $uibModalInstance;
	}

	cancel() {
		return this.$uibModalInstance.dismiss('cancel');
	}
}
